import { useMutation } from '@tanstack/react-query'
import { useAuth } from 'src/contexts/auth'
import { CoverageProcessController } from 'src/controllers/coverage-process.controller'
import { CoverageProcessParams } from 'src/domain/coverage-process'

const coverageProcessController = new CoverageProcessController()

export function useCreateCoverageProcess() {
  const { userFarm: farmId } = useAuth()

  return useMutation({
    mutationKey: ['createCoverageProcess'],
    mutationFn: (coverageProcessDto: CoverageProcessParams) =>
      coverageProcessController.createCoverageProcess(farmId!, coverageProcessDto)
  })
}
